import { Col, Form, Select } from "antd";
import { useCallback, useEffect, useMemo } from "react";

export const SelectEE = ({
  form,
  fieldKey,
  until,
  emptyNights,
  configuracion,
  configSpecie,
  selectedLevelDesde,
  specieId,
  untilSpecieId,
  isloadingInfoDataBase,
}) => {
  const levelSpeciesFiltered = useMemo(() => {
    const levels = Array.isArray(configuracion?.LevelsSpecie)
      ? configuracion.LevelsSpecie
      : [];

    return levels.filter((level) => level?.specie?.code === until);
  }, [configuracion?.LevelsSpecie, until]);

  const cant = useMemo(() => {
    return levelSpeciesFiltered.filter((x) => x?.status_id !== 6);
  }, [levelSpeciesFiltered]);

  const nightsOptions = useMemo(() => {
    return Array.isArray(emptyNights) ? emptyNights : [];
  }, [emptyNights]);

  const handleSelectLevel = (value, sectionIndex, untilLevel) => {
    const fields = form.getFieldsValue();
    const sections = Array.isArray(fields?.sections) ? [...fields.sections] : [];

    if (!sections[sectionIndex]) return;

    const currentSection = { ...sections[sectionIndex] };
    const currentSelectedNights = {
      ...(currentSection.selectedNights || {}),
    };

    const match = Array.isArray(configSpecie)
      ? configSpecie.find((x) => Number(x?.until_level) === Number(untilLevel))
      : undefined;

    const configId = match?.id ?? "undefined";

    currentSection.selectedNights = {
      ...currentSelectedNights,
      [`${untilLevel}-${configId}`]: value,
    };

    sections[sectionIndex] = currentSection;
    form.setFieldsValue({ sections });
  };

  const syncDefaultSelects = useCallback(() => {
    const fields = form.getFieldsValue();
    const sections = Array.isArray(fields?.sections) ? [...fields.sections] : [];

    if (!sections[fieldKey]) return;

    const currentSection = { ...sections[fieldKey] };

    const currentLevels = Array.isArray(currentSection.level)
      ? [...currentSection.level]
      : cant.map((lvl) => ({ ...lvl }));

    // limpiar siempre primero para evitar arrastre visual
    const clearedLevels = currentLevels.map((lvl) => ({
      ...lvl,
      selectedNights: undefined,
    }));

    currentSection.level = clearedLevels;
    currentSection.selectedNights = {};

    if (Array.isArray(configSpecie) && configSpecie.length > 0) {
      configSpecie.forEach((cnfspe) => {
        const untilLevelId = Number(cnfspe?.untilLevel?.id);
        const untilLevelCode = Number(cnfspe?.until_level);
        const nightAssigned = cnfspe?.rangeEmptyNight?.number_assigned;

        const levelIndex = currentSection.level.findIndex(
          (val) => Number(val?.id) === untilLevelId
        );

        if (levelIndex !== -1) {
          currentSection.level[levelIndex] = {
            ...currentSection.level[levelIndex],
            selectedNights: nightAssigned,
          };
        }

        currentSection.selectedNights = {
          ...currentSection.selectedNights,
          [`${untilLevelCode}-${cnfspe?.id}`]: nightAssigned,
        };
      });
    }

    sections[fieldKey] = currentSection;
    form.setFieldsValue({ sections });
  }, [form, fieldKey, cant, configSpecie, selectedLevelDesde, specieId, untilSpecieId]);

  useEffect(() => {
    syncDefaultSelects();
  }, [syncDefaultSelects]);

  return (
    <Form.List name={[fieldKey, "level"]} initialValue={cant} key={fieldKey}>
      {(levelFields) => {
        return (
          <>
            {levelFields.map((lvlField) => {
              const currentLevel = cant?.[lvlField.name];
              const currentUntilLevel = currentLevel?.id;

              return (
                <Col xs={24} md={12} lg={12} key={lvlField.key}>
                  <Form.Item
                    name={[lvlField.name, "selectedNights"]}
                    label={currentLevel?.name}
                    rules={
                      currentLevel?.status_id !== 2
                        ? [
                            {
                              required: true,
                              message: "Este campo es requerido",
                            },
                          ]
                        : []
                    }
                  >
                    <Select
                      showSearch
                      optionFilterProp="children"
                      placeholder="Seleccione.."
                      onChange={(value) =>
                        handleSelectLevel(value, fieldKey, currentUntilLevel)
                      }
                      disabled={
                        currentLevel?.status_id === 2 || isloadingInfoDataBase
                      }
                      loading={isloadingInfoDataBase}
                      allowClear
                    >
                      {nightsOptions.map((night) => (
                        <Select.Option value={night.number_assigned} key={night.id}>
                          {night.number_assigned !== 0
                            ? `${night.number_assigned} Noches de Vacío`
                            : "Sin restricción"}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              );
            })}
          </>
        );
      }}
    </Form.List>
  );
};

export default SelectEE;